import React from "react";
import {
  TableBody, TableCell, TableHead, TableRow, Table
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CountUp from "react-countup";

export default class ComponentToPrint extends React.Component {

  render() {
    const TrialBalanceDetailList = this.props.trialBalanceDetails;
    const PdfExcelGeneralDetails = this.props.PdfExcelGeneralDetails;

    return (
      <div style={{ width: '100%' }} >
        <div>
          <br />
          <h2><center>Trial Balance Report</center></h2>
          <div>&nbsp;</div>
          <h2><center>Group: {PdfExcelGeneralDetails.groupName} - Estate: {PdfExcelGeneralDetails.factoryName}</center></h2>
          <div>&nbsp;</div>
          <h2><center>From {PdfExcelGeneralDetails.fromDate} To {PdfExcelGeneralDetails.endDate}</center></h2>
          <div>&nbsp;</div>
          <div >
            <Table style={{ width: '100%', border: "1px black solid" }} size="small" aria-label="simple table">
              <TableHead>
                <TableRow >
                  <TableCell style={{ padding: "5px" }} align={'left'}>Account Number</TableCell>
                  <TableCell style={{ padding: "5px" }} align={'left'}>Account Name</TableCell>
                  <TableCell style={{ padding: "5px" }} align={'right'}>Year To Date Debit (LKR)</TableCell>
                  <TableCell style={{ padding: "5px" }} align={'right'}>Year To Date Credit (LKR)</TableCell>
                  <TableCell align={'right'} style={{ backgroundColor: "#F4F6F8", padding: "5px" }} >Transaction Debit (LKR)</TableCell>
                  <TableCell align={'right'} style={{ backgroundColor: "#F4F6F8", padding: "5px" }} >Transaction Credit (LKR)</TableCell>
                  <TableCell style={{ padding: "5px" }} align={'right'}>Closing Debit (LKR)</TableCell>
                  <TableCell style={{ padding: "5px" }} align={'right'}>Closing Credit (LKR)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TrialBalanceDetailList.map((data, index) => (
                  <TableRow key={index} style={{ border: "1px black solid" }}>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'left'} component="th" scope="row">
                      {data.accountNumber}
                    </TableCell>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'left'} component="th" scope="row" >
                      {data.accountName}
                    </TableCell>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                      <CountUp
                        end={data.openDebit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                      <CountUp
                        end={data.openCredit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                    <TableCell align={'right'} style={{ backgroundColor: "#F4F6F8", padding: "5px", font: "10px" }} component="th" scope="row" >
                      <CountUp
                        end={data.transDebit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                    <TableCell align={'right'} style={{ backgroundColor: "#F4F6F8", padding: "5px", font: "10px" }} component="th" scope="row" >
                      <CountUp
                        end={data.transCredit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                      <CountUp
                        end={data.closingDebit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                    <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                      <CountUp
                        end={data.closingCredit.toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow style={{ border: "1px black solid" }}>
                  <TableCell style={{ padding: "5px", font: "10px" }} align={'left'} component="th" scope="row" >
                    <Typography style={{ fontWeight: 'bold' }}>
                      Total (LKR)
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: "5px" }} align={'left'} component="th" scope="row" >
                  </TableCell>
                  <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalOpenDebit, item) => totalOpenDebit + item.openDebit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalOpenCredit, item) => totalOpenCredit + item.openCredit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ backgroundColor: "#F4F6F8", padding: "5px", font: "10px" }} >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalTransDebit, item) => totalTransDebit + item.transDebit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ backgroundColor: "#F4F6F8", padding: "5px", font: "10px" }} >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalTransCredit, item) => totalTransCredit + item.transCredit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalClosingDebit, item) => totalClosingDebit + item.closingDebit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell style={{ padding: "5px", font: "10px" }} align={'right'} component="th" scope="row" >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={TrialBalanceDetailList.reduce((totalClosingCredit, item) => totalClosingCredit + item.closingCredit, 0).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                </TableRow>

                <TableRow style={{ border: "1px black solid" }}>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "1px black solid", padding: "5px" }} >
                    <Typography style={{ fontWeight: 'bold' }}>
                      Unbalance (LKR)
                    </Typography>
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "1px black solid", padding: "5px" }} >
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "1px black solid", padding: "5px" }} >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={(TrialBalanceDetailList.reduce((totalOpenDebit, item) => totalOpenDebit + item.openDebit, 0) - (TrialBalanceDetailList.reduce((totalOpenCredit, item) => totalOpenCredit + item.openCredit, 0))).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "1px black solid", padding: "5px" }} >
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ backgroundColor: "#F4F6F8", borderBottom: "1px black solid", padding: "5px" }} >
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={(TrialBalanceDetailList.reduce((totalTransDebit, item) => totalTransDebit + item.transDebit, 0) - (TrialBalanceDetailList.reduce((totalTransCredit, item) => totalTransCredit + item.transCredit, 0))).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "1px black solid", backgroundColor: "#F4F6F8", padding: "5px" }} >
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "1px black solid", padding: "5px" }}>
                    <Typography style={{ fontWeight: 'bold' }}>
                      <CountUp
                        end={(TrialBalanceDetailList.reduce((totalClosingDebit, item) => totalClosingDebit + item.closingDebit, 0) - (TrialBalanceDetailList.reduce((totalClosingCredit, item) => totalClosingCredit + item.closingCredit, 0))).toFixed(2)}
                        decimals={2}
                        decimal="."
                        separator=","
                        duration={0.1}
                      />
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </div>
      </div >

    );

  }

}
